'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _validation = require('./validation');

Object.keys(_validation).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _validation[key];
        }
    });
});

var _ramda = require('ramda');

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _browserComponents = require('./browser-components');

var _helpers = require('./helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var FormHelper = exports.FormHelper = function (_Component) {
    _inherits(FormHelper, _Component);

    function FormHelper() {
        _classCallCheck(this, FormHelper);

        var _this = _possibleConstructorReturn(this, (FormHelper.__proto__ || Object.getPrototypeOf(FormHelper)).apply(this, arguments));

        _this.unmounted = false;
        _this.state = {
            loading: false,
            updatedObject: null,
            touched: {}
        };
        return _this;
    }

    _createClass(FormHelper, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unmounted = true;
        }
    }, {
        key: 'setLoading',
        value: function setLoading(loading) {
            if (!this.unmounted) {
                this.setState({ loading: loading });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                style = _props.style,
                fields = _props.fields,
                value = _props.value,
                onSave = _props.onSave,
                _onChange = _props.onChange,
                saveButton = _props.saveButton,
                _props$formComponent = _props.formComponent,
                Form = _props$formComponent === undefined ? 'form' : _props$formComponent,
                _props$inputComponent = _props.inputComponent,
                Input = _props$inputComponent === undefined ? _browserComponents.BrowserInput : _props$inputComponent,
                _props$buttonComponen = _props.buttonComponent,
                Button = _props$buttonComponen === undefined ? _browserComponents.BrowserButton : _props$buttonComponen,
                buttonProps = _props.buttonProps,
                formId = _props.formId,
                dirtyCheck = _props.dirtyCheck,
                errorOnTouched = _props.errorOnTouched,
                disabled = _props.disabled;
            var _state = this.state,
                updatedObject = _state.updatedObject,
                loading = _state.loading;

            var changed = !!_onChange || !dirtyCheck;
            updatedObject = _onChange ? value : updatedObject || value;

            var _isValid = (0, _helpers.isValid)(fields, updatedObject),
                validatedFields = _isValid.validatedFields,
                valid = _isValid.valid;

            return React.createElement(Form, { id: formId, style: style, onSubmit: function onSubmit(e) {
                    e.preventDefault();
                    var returnValue = onSave(updatedObject);
                    if (returnValue && returnValue.then && returnValue.catch) {
                        _this2.setLoading(true);
                        returnValue.catch(function (error) {
                            _this2.setLoading(false);
                            throw error;
                        }).then(function () {
                            return _this2.setLoading(false);
                        });
                    }
                } }, validatedFields.map(function (field, i) {
                if (!field) return null;
                if (field.props) return (0, _react.cloneElement)(field, { key: i });

                var render = field.render,
                    component = field.component,
                    path = field.path,
                    validations = field.validations,
                    validationError = field.validationError,
                    inputProps = __rest(field, ["render", "component", "path", "validations", "validationError"]);

                if ((0, _ramda.path)(path, updatedObject) !== (0, _ramda.path)(field.path, value)) {
                    changed = true;
                }
                var fieldValue = (0, _helpers.getValue)(field.path, updatedObject);
                if (validationError) {
                    var validation = validations && validations[field.validationError];
                    inputProps.error = validation && validation.text || '';
                }
                if (errorOnTouched) {
                    var hideError = !_this2.state.touched[path.join('.')];
                    if (hideError && Array.isArray(errorOnTouched)) {
                        hideError = errorOnTouched.includes(validationError);
                    }
                    if (hideError) {
                        var oldBlur = inputProps.onBlur;
                        inputProps.onBlur = function (e) {
                            _this2.setState({
                                touched: __assign({}, _this2.state.touched, _defineProperty({}, path.join('.'), true))
                            });
                            if (oldBlur) return oldBlur(e);
                        };
                        inputProps.error = undefined;
                    }
                }
                var props = __assign({ key: i, value: fieldValue, disabled: disabled }, inputProps, { onChange: function onChange(value) {
                        var newUpdatedObject = (0, _ramda.set)((0, _ramda.lensPath)(path), value, updatedObject);
                        if (field.onChange) {
                            var modifiedObject = field.onChange(newUpdatedObject);
                            if (modifiedObject) {
                                newUpdatedObject = modifiedObject;
                            }
                        }
                        if (_onChange) {
                            _onChange(newUpdatedObject, (0, _helpers.isValid)(fields, newUpdatedObject).valid);
                        } else {
                            _this2.setState({ updatedObject: newUpdatedObject });
                        }
                    } });
                if (render) {
                    return render(props);
                } else {
                    var Field = component || Input;
                    return React.createElement(Field, __assign({}, props));
                }
            }), saveButton && React.createElement(Button, __assign({ type: 'submit', value: updatedObject, loading: loading, disabled: !changed || !valid || disabled }, buttonProps), saveButton));
        }
    }]);

    return FormHelper;
}(_react.Component);
//# sourceMappingURL=index.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./dist/src/index.js
 ** module id = 51
 ** module chunks = 0
 **/